exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkage-icons{display:flex;align-items:center}.linkage-icons .link-icon-container{margin-left:4px;position:relative;overflow:hidden;flex-shrink:0}.linkage-icons .link-icon-container .link-icon{width:100%;height:100%;position:absolute;left:-100%;top:-100%}.icon-link-help{margin-left:4px;font-size:14px;color:#022e6a;cursor:pointer;font-weight:400}.link-popover .link-item{color:var(--pui-black-font-color-4,#787878)}", ""]);

// exports
